import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { CustomRendererComponent, HeaderRendererComponent } from '../custom-renderer/custom-renderer.component';
import { ColDef, GridApi, ICellRendererParams } from 'ag-grid-community';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CheckboxService } from '../custom-renderer/custom-renderer.component';
import { Subscription } from 'rxjs';
import { AgGridAngular } from 'ag-grid-angular';
import { ConditionalExpr } from '@angular/compiler';

@Component({
  selector: 'app-trip-print',
  templateUrl: './trip-print.component.html',
  styleUrls: ['./trip-print.component.scss']
})
export class TripPrintComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChildren('checkboxes') checkboxes!: QueryList<ElementRef>;
  @ViewChild('agGrid', { static: false }) agGrid!: AgGridAngular;

  searchCarrier: FormGroup = this.fb.group({
    carrier_name: [''],
  })

  listOfCarrier = [];
  
  // variable to store universal filter 
  universalFilter = ''

  getMatCheckboxesWithId(id: string): ElementRef[] {
    return this.checkboxes.filter(checkbox => {
      return checkbox.nativeElement.id === id;
    });
  }

  trip_uuid!: string;
  carrier_name!: string;
  shipments: Array<{ [key: string]: string | number | object | boolean }> = [];

  private subscription: Subscription;

  constructor(private http: HttpClient, private fb: FormBuilder, private route: ActivatedRoute, private checkboxService: CheckboxService, private router: Router) {
    this.subscription = this.checkboxService.functionDeselect.subscribe((columnKey: string) => {
      this.deselectAllCheckboxes(columnKey);
    });
    this.subscription = this.checkboxService.functionSelect.subscribe((columnKey:string) => {
      this.selectAllCheckboxes(columnKey);
    })
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.trip_uuid = params.get('uuid') || '';
      this.carrier_name = params.get('carrier_name') || '';
    })
    console.log('uuid:', this.trip_uuid)
    const url = "/api/shipment_lists/trip_lists.php"
    this.http.get(url, { params: { name: 'shipment_and_receiving', trip_list_uuid: this.trip_uuid, carrier_name:this.carrier_name, command: 'TRIP_PRINT' } }).subscribe((response: any) => {
      if (response) {
        console.log(response.data)
        this.shipments = response.data;
      }
    })
    this.http.get(url, { params: { name: 'shipment_and_receiving', trip_list_uuid: this.trip_uuid, command: 'TRIP_PRINT_CARRIER' } }).subscribe((response: any) => {
      this.listOfCarrier = response.data.map((item: any) => {
        return item.carrier_name;
      });
    })    
    this.http.get(url, { params: { name: 'shipment_and_receiving', trip_list_uuid: this.trip_uuid, command: 'TRIP_PRINT_ENABLE' } }).subscribe((response: any) => {
    })        
    this.toggleCheckboxesInColumn('Print Bill of Lading', false);
  }


  createColDef() {

    const bolColDef = {
      field: 'print_bol',
      colId: 'Print Enable',
      headerComponent: HeaderRendererComponent,
      headerComponentParams: {
        displayName: { name: 'Print Enable', uuid: 'lading_uuid', carrier_name: this.carrier_name }
      },
      cellRenderer: CustomRendererComponent,
      cellRendererParams: { displayName: 'Lading' },
      width: 220,
    };


    this.gridApi.setGridOption('columnDefs', 
    [
      { field: 'lading_uuid', headerName: 'UUID', hide: true },
      { field: 'load_end', headerName: 'Date', },
      { field: 'pro_bill', headerName: 'Pro Bill Number', width: 200 },
      { field: 'store_number', headerName: 'Store Number', width: 150 },
      { field: 'alternate_reference', headerName: 'Work Order Number', },
      { field: 'carrier_name', headerName: 'Carrier Organization', width: 350, filter: 'agTextColumnFilter'},
      bolColDef
    ])
  }


  defaultColDef = {
    sortable: true,
    filter: true,
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: false
  };

  customGroupFooterCellRenderer(params: any): string {
    return '<button>Select All</button>'; // Your custom rendering logic here
  }

  gridOptions = {
    // Other grid configurations...

    autoGroupColumnDef: {
      headerName: 'Group', // Assuming it's the group column
      field: 'date', // Replace with your field
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: {
        footerValueGetter: 'date', // Value to be displayed in the footer
      },
      cellRendererSelector: function (params: any) {
        if (params.node.footer) {
          return { renderer: 'customGroupFooterCellRenderer' };
        } else {
          return { renderer: 'agGroupCellRenderer' };
        }
      }
    },
    frameworkComponents: {
      customGroupFooterCellRenderer: HeaderRendererComponent, // Your custom component for the group footer
    },
  };


  private gridApi!: GridApi;
  private params!: any;

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi = params.api;
    this.params = params;
    this.createColDef();
  }
  
  toggleCheckboxesInColumn(columnToToggle: string, checked: boolean): void {
    const url = "/api/shipment_lists/shipment_lists.php"
    console.log("toggleCheckboxesInColumn");
    if (!this.gridApi) return; // Ensure gridApi is available
    this.gridApi.forEachNodeAfterFilterAndSort((rowNode) => {

      this.http.get(url, { params: { name: 'shipment_and_receiving', shipment_list_uuid: rowNode.data.shipment_list_uuid, command: 'SHIPMENT_PRINT_TOGGLE' } }).subscribe((response: any) => {
      })     
      if (rowNode.data && columnToToggle in rowNode.data) {
        // Manipulate checkboxes in the desired column
        rowNode.setDataValue(columnToToggle, checked);
      }
    });
  }

  selectAllCheckboxes(columnKey: string) {

    if (!this.gridApi) return;
    const colDef = this.gridApi.getColumnDef(columnKey);
    const columnDefs: ColDef[] = this.gridApi.getAllGridColumns().map(column => column.getColDef());
    const targetColumn = columnDefs.find(column => column.colId === columnKey);

    if (targetColumn && targetColumn.headerComponentParams) {
      targetColumn
      targetColumn.cellRendererParams.displayName = true;
      this.gridApi.refreshCells({ force: true });
    }

    const trip_print_enable_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=TRIP_PRINT_ENABLE`;    
    var postData = {
      trip_list_uuid: this.trip_uuid
    }
    console.log('Select All Boxes', postData);
    this.http.post<any>(trip_print_enable_url, postData)
      .subscribe(response => {
      })        
  }

  deselectAllCheckboxes(columnKey: string) {

    if (!this.gridApi) return;
    const colDef = this.gridApi.getColumnDef(columnKey);
    const columnDefs: ColDef[] = this.gridApi.getAllGridColumns().map(column => column.getColDef());
    const targetColumn = columnDefs.find(column => column.colId === columnKey);

    if (targetColumn && targetColumn.headerComponentParams) {
      targetColumn
      targetColumn.cellRendererParams.displayName = false;
      this.gridApi.refreshCells({ force: true });
    }

    const trip_print_enable_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=TRIP_PRINT_DISABLE`;    
    var postData = {
      trip_list_uuid: this.trip_uuid
    }
    console.log('Deselect All Boxes', postData);
    this.http.post<any>(trip_print_enable_url, postData)
      .subscribe(response => {
      })       
  }

  ngAfterViewInit() {
    const palletCheckboxes = this.getMatCheckboxesWithId('Lading');
    console.log('Checkboxes with ID "Pallet":', this.checkboxes);
    if (this.agGrid) {
      this.route.queryParamMap.subscribe((params) => {
        const filterText = params.get('carrier_name');
        
        if (filterText) {
          this.applyNameFilter(filterText);
        }
        else {
          console.log('no valid record')
        }
      });
    }
  }

  applyNameFilter(filterText: string) {
    if (this.agGrid) {
      console.log('hello world', filterText)
      this.agGrid.api.setFilterModel({
        carrier_name: {
          filterType: "text",
          type: "equals",
          filter: filterText,
        },
      });
      this.agGrid.api?.onFilterChanged();
    }
  }

  search() {
    this.carrier_name = this.searchCarrier.get('carrier_name')?.value;
    if (this.carrier_name) {
      this.router.navigate(['/trip_print', this.trip_uuid], { queryParams: {carrier_name: this.carrier_name } });
    }
    else {
      console.log('Invalid search data.')
    }
  }

  resetSearch() {
    this.router.navigate(['/trip_print', this.trip_uuid]);
    this.searchCarrier.get('carrier_name')?.setValue('');
    this.carrier_name = '';
    this.createColDef();
  }

  carrierChange(event: any) {
      this.carrier_name = event.value;
      this.createColDef();
      this.router.navigate(['/trip_print', this.trip_uuid], { queryParams: {carrier_name: event.value } });
  }


    // Function to get a column by colId
    getColumnByColId(colId: string) {
      const allColumns = this.gridApi.getColumns(); //changed from this.columnApi.getAllColumns()
      return allColumns?.find(column => column.getColId() === colId);
    }

    isPrintingBillOfLading: boolean = false;
    print_Bill_of_Lading() {
      let endpoint = '';
     endpoint = `/api/work_orders/print_pdfs/newams_print_trip.php?uuid=${this.trip_uuid}&carrier_name=${this.carrier_name}&print_type=print_bol`;
     this.isPrintingBillOfLading = true;

      this.http.get(endpoint, {
        responseType: 'blob', // Expect binary data
        params: { }
      }).subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        window.open(url);
        // Optionally revoke the object URL after some time to free memory
        setTimeout(() => window.URL.revokeObjectURL(url), 100);
        this.isPrintingBillOfLading = false;
      });       

    }

    isPrintingConsolidateBOL: boolean = false;
    print_Consolidated_Bill_of_Lading() {
      let endpoint = '';
     endpoint = `/api/work_orders/print_pdfs/newams_print_trip.php?uuid=${this.trip_uuid}&carrier_name=${this.carrier_name}&print_type=print_consolidated_bol`;
     this.isPrintingConsolidateBOL = true;
    
      this.http.get(endpoint, {
        responseType: 'blob', // Expect binary data
        params: { }
      }).subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        window.open(url);
        // Optionally revoke the object URL after some time to free memory
        setTimeout(() => window.URL.revokeObjectURL(url), 100);
        this.isPrintingConsolidateBOL = false;
      });       

    }

    isPrintingBOLPalletLabel: boolean = false;
    print_BOL_Pallet_Label() {
      let endpoint = '';
     endpoint = `/api/work_orders/print_pdfs/newams_print_trip.php?uuid=${this.trip_uuid}&carrier_name=${this.carrier_name}&print_type=print_bol_label`;
     this.isPrintingBOLPalletLabel = true;

      this.http.get(endpoint, {
        responseType: 'blob', // Expect binary data
        params: { }
      }).subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        window.open(url);
        // Optionally revoke the object URL after some time to free memory
        setTimeout(() => window.URL.revokeObjectURL(url), 100);
        this.isPrintingBOLPalletLabel = false;
      });       
    }

    isPrintingPalletLabel: boolean = false;
    print_Pallet_Label() {
      let endpoint = '';
     endpoint = `/api/work_orders/print_pdfs/newams_print_trip.php?uuid=${this.trip_uuid}&carrier_name=${this.carrier_name}&print_type=print_label`;
     this.isPrintingPalletLabel = true;

      this.http.get(endpoint, {
        responseType: 'blob', // Expect binary data
        params: { }
      }).subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        window.open(url);
        // Optionally revoke the object URL after some time to free memory
        setTimeout(() => window.URL.revokeObjectURL(url), 100);
        this.isPrintingPalletLabel = false; 
      });       

    }    

    isPrintingTrailerLabel: boolean = false;
    print_Trailer_Label() {
      let endpoint = '';
     endpoint = `/api/work_orders/print_pdfs/newams_print_trip.php?uuid=${this.trip_uuid}&carrier_name=${this.carrier_name}&print_type=print_trailer`;
     this.isPrintingTrailerLabel = true;

      this.http.get(endpoint, {
        responseType: 'blob', // Expect binary data
        params: { }
      }).subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        window.open(url);
        // Optionally revoke the object URL after some time to free memory
        setTimeout(() => window.URL.revokeObjectURL(url), 100);
        this.isPrintingTrailerLabel = false;       
      });       

    }      
  

  ngOnDestroy(): void {
    this.subscription.unsubscribe(); // Unsubscribe to prevent memory leaks
  }

}
